import { $subscriber, cr } from "fire-wind-water";
import { splitContainer, updateContainer } from "../help/data";
import { settings } from "./setting";

export function template(cn): void {
  let data = [];
  let isT = false;
  let isP = false;
  $subscriber.subscribe("scms-template", (res) => {
    data = res.data;
    isT = true;
    if (isP && isT) {
      const d = cr.extend(true, [], data);
      splitContainer(d);
      cn(d);
    }
  });
  $subscriber.subscribe("scms-page", (res) => {
    isP = true;
    settings.page = { items: res.data.items };
    settings.pageId = parseInt(res.data.pageId, 10);
    settings.pageInfo = (settings.page.items || []).filter((d) => {
      return parseInt(d.id, 10) === settings.pageId;
    })[0];
    if (isP && isT) {
      const d = cr.extend(true, [], data);
      splitContainer(d);
      cn(d);
    }
  });
}

export function component(cn) {
  $subscriber.on("scms-component", (res) => {
    const data = res.data.content;
    data.orderId = res.data.index;
    data.historyOrderId = res.data.index;
    updateContainer(res.data);
    cn(res.data);
  });
}
